import "./index.scss";
import "react-toastify/dist/ReactToastify.css";

import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactNode } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { ActiveEditorProvider, CeramicProvider, QueriesProvider } from "@/hooks";

import App from "./App";
import ErrorPage from "./ErrorPage";
import { composeClient } from "./fetcher";
import Public from "./Public";

Sentry.init({
  dsn: "https://e984d689379040899a15230eb81bd55f@sentry.lateral.io/12",
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 1.0,
  enabled: import.meta.env.MODE === "production",
});

const queryClient = new QueryClient();

const addProviders = (element: ReactNode) => {
  return (
    <ActiveEditorProvider>
      <QueriesProvider>{element}</QueriesProvider>
    </ActiveEditorProvider>
  );
};

export const router = createBrowserRouter([
  {
    path: "/:pageId?",
    element: addProviders(<App />),
    errorElement: <ErrorPage />,
  },
  {
    path: "/project/:projectId/:pageId?",
    element: addProviders(<App />),
    errorElement: <ErrorPage />,
  },
  {
    path: "/public/:projectPublicId/:pageId?",
    element: addProviders(<Public />),
    errorElement: <ErrorPage />,
  },
]);
let container: HTMLElement | null = null;

document.addEventListener("DOMContentLoaded", function (event) {
  if (!container) {
    container = document.getElementById("app") as HTMLElement;
    const root = ReactDOM.createRoot(container);
    root.render(
      <QueryClientProvider client={queryClient}>
        <CeramicProvider client={composeClient}>
          <RouterProvider router={router} />
        </CeramicProvider>
        <ToastContainer />
        {/* <ReactQueryDevtools position="bottom-right" initialIsOpen={false} /> */}
      </QueryClientProvider>
    );
  }
});
